import styled from 'styled-components';
import { link } from '+/styles/reusable/linkStyles';

export const Content = styled.div`
  a {
    ${link}
  }
`;
